module.exports = __webpack_public_path__ + "static/img/1.e753829.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/1.png
// module id = Pi+L
// module chunks = 0